import { render, staticRenderFns } from "./Inode.vue?vue&type=template&id=2f1d4289&scoped=true&lang=pug"
import script from "./Inode.vue?vue&type=script&lang=js"
export * from "./Inode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1d4289",
  null
  
)

export default component.exports